module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serverisnotavailable-panel-wrapper"
  }, [_c('div', {
    staticClass: "serverisnotavailable-panel"
  }, [_c('div', {
    staticClass: "serverisnotavailable-header"
  }, [_c('span', {
    staticClass: "serverisnotavailable-app-title"
  }, [_vm._v(_vm._s(_vm.appSettings.appName))]), _vm._v(" "), _c('span', {
    staticClass: "serverisnotavailable-text"
  }, [_vm._v("Нет связи с сервером приложения")])]), _vm._v(" "), _c('Button', {
    staticClass: "serverisnotavailable-try-recconect-button no-circle",
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.returnToWelcomePage
    }
  }, [_vm._v(_vm._s(_vm.i18n.serverIsNotAvailable.tryReconnectButtonText))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768fa142","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonPages/ServerIsNotAvailable.vue
// module id = 363
// module chunks = 0